const CAP = {
  title: "¿Por qué usar Bitcoin? y Bitcoin en la práctica",
  subtitle: "Curso GRATIS de BITCOIN con CERTIFICADO",
  status: "Complete",
  sections: [
    {
      heading: "¿Por qué usar Bitcoin?",
      text: [
        "Bitcoin no es solo dinero digital: representa una nueva forma de entender, transferir y almacenar valor sin depender de bancos, gobiernos o entidades emisoras. Es una forma de dinero global, descentralizado, rápido, seguro y transparente.",
        "Al igual que en la historia el dinero ha ido evolucionando desde la sal, el oro, los metales, los billetes y ahora las tarjetas y pagos digitales, Bitcoin representa el siguiente paso en esa evolución. Es el 'dinero del futuro' porque está diseñado para el mundo digital.",
        "El término salario, por ejemplo, viene del latín 'Salarium', que hacía referencia a pagos en sal. Luego llegaron los metales, y más tarde, los billetes. Ahora estamos llegando a una era donde el dinero digital descentralizado —como Bitcoin— se convierte en la forma más eficiente, segura y universal de intercambio de valor.",
        "Cuando se introdujeron los billetes o las tarjetas, muchas personas dudaron de su seguridad y credibilidad. Hoy pasa lo mismo con Bitcoin, pero cada etapa de evolución trae beneficios enormes: eficiencia, accesibilidad, libertad financiera, seguridad y globalización.",
        "Bitcoin te permite enviar dinero a cualquier parte del mundo de forma casi instantánea, sin intermediarios, con comisiones mucho más bajas y con una transparencia total gracias a la tecnología blockchain.",
        "Así como el correo electrónico revolucionó la comunicación, Bitcoin está revolucionando el sistema financiero."
      ]
    },
    {
      heading: "Bitcoin en la práctica, ¿cómo se utiliza?",
      text: [
        "Usar Bitcoin es tan sencillo como usar WhatsApp o enviar un correo electrónico. Aunque detrás hay tecnología avanzada como blockchain, criptografía y minería, para el usuario común, enviar Bitcoin es tan simple como escanear un código QR o copiar una dirección.",
        "No necesitas entender cómo funciona la criptografía o los protocolos de red para utilizar Bitcoin, igual que no necesitas conocer SMTP o TCP/IP para enviar un email.",
        "El uso básico de Bitcoin implica tres elementos fundamentales: un monedero (wallet), una dirección y una transacción."
      ]
    },
    {
      heading: "El monedero (Wallet)",
      text: [
        "El monedero o 'wallet' es una aplicación o programa que permite enviar, recibir y almacenar tus bitcoin de forma segura. Es similar a una cuenta bancaria digital, pero sin banco.",
        "Existen wallets para dispositivos móviles, ordenadores y también en versión web. Una wallet puede gestionar múltiples direcciones Bitcoin y está protegida por claves criptográficas.",
        "Ejemplos de wallets: Trust Wallet,  Exodus, Ledger, entre otras."
      ]
    },
    {
      heading: "Las direcciones",
      text: [
        "Una dirección Bitcoin funciona como un número de cuenta. Es una cadena alfanumérica única que permite recibir fondos.",
        "Para enviar o recibir bitcoin, solo necesitas una dirección. Estas direcciones también pueden mostrarse como códigos QR para facilitar su uso.",
        "Compartir tu dirección no supone ningún riesgo, ya que con ella solo pueden enviarte bitcoin, pero no acceder a tus fondos."
      ]
    },
    {
      heading: "Las transacciones",
      text: [
        "Una transacción es el envío de bitcoin desde una dirección hacia otra. Cada transacción queda registrada de forma pública y permanente en la blockchain.",
        "Aunque Bitcoin no es una moneda física, tiene un valor equivalente en todas las monedas tradicionales (euro, dólar, peso, etc.). El valor cambia constantemente según la oferta y la demanda.",
        "Puedes enviar cualquier cantidad de Bitcoin, incluso fracciones muy pequeñas llamadas satoshis (0.00000001 BTC)."
      ]
    },
    {
      heading: "Mineros y confirmaciones",
      text: [
        "Cuando envías bitcoin, la transacción aparece instantáneamente en tu wallet, pero requiere confirmaciones para ser validada por la red.",
        "Los mineros son computadoras encargadas de verificar transacciones y asegurar la red. Ellos reciben comisiones por realizar esta tarea.",
        "El usuario puede elegir pagar una comisión más alta o baja según la urgencia de su transacción. Cuanto mayor sea la comisión, más rápido será el procesamiento."
      ]
    },
    {
      heading: "¿Es Bitcoin anónimo?",
      text: [
        "Bitcoin no es anónimo, sino seudónimo. Todas las transacciones son públicas y transparentes, pero no están directamente vinculadas a tu identidad.",
        "Tus transacciones quedan registradas en la blockchain para siempre, pero solo se muestran direcciones, montos y fechas, no nombres personales."
      ]
    },
    {
      heading: "¿Qué aprenderás más adelante?",
      text: [
        "Cómo enviar y recibir bitcoin de forma segura",
        "Cómo se fija su precio",
        "Dónde se puede pagar con BTC",
        "Cómo cambiar Bitcoin por otras criptomonedas",
        "Cómo proteger tus claves privadas",
        "Cómo funciona la minería y la red"
      ]
    }
  ]
};

export default CAP;
